import types from "../actions/actionTypes";
import initialState from "./initialState";


export default function projectsReducer(state = initialState.projectsList, action) {

    const updateProjectCompleteStatus = (current, update) => {
        const projectToUpdate = current.find(p => p.id === update.id);
        const updated = { ...projectToUpdate, complete: update.complete };
        return merge(current, [updated]);
    }

    const mergeInFullCompleteProjectsUpdate = (current, updates) => {
        return mergeFullUpdate(current, updates, true);
    }

    const mergeInFullInCompleteProjectsUpdate = (current, updates) => {
        return mergeFullUpdate(current, updates, false);
    }

    const mergeFullUpdate = (current, updates, complete) => {
        const projectsToKeep = current.filter(project => project.complete === !complete);
        return [...projectsToKeep, ...updates];       
    }

     const merge = (current, updates) => {       
        let result = current.map(project => {
            const updateOrNothing = updates.find(pi => pi.id === project.id);
            if (updateOrNothing !== undefined) {
                return updateOrNothing;
            }
            return project;
         });   
        const existingIds = result.map(project => project.id);
        const newProjects = updates.filter(project => !existingIds.includes(project.id));
        return [...result, ...newProjects];   
    }

    const deleteProject = (current, id) => {  
        return current.filter(project => project.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_PROJECTS_SUCCESS:
            return mergeInFullInCompleteProjectsUpdate(state, action.projectsList);
        case types.LOAD_PROJECTS_UPDATE_SUCCESS:
            return merge(state, action.projectsList);
         case types.DELETED_PROJECT:    
            return deleteProject(state, action.id);
        case types.DELETED_PROJECT_INCOMING:
            return deleteProject(state, action.payload); 
        case types.LOAD_COMPLETEPROJECTS_SUCCESS:
            return mergeInFullCompleteProjectsUpdate(state, action.projectsList);
        case types.UPDATED_PROJECT_SUCCESS:
            return updateProjectCompleteStatus(state, action.project);
        case types.UPDATED_PROJECT_INCOMING:
            return updateProjectCompleteStatus(state, action.payload);
        default:
            return state;
    }
}